import { useEffect } from 'react';
export const useFilterRestQueryParamOnHide = (hidden, handleChange) => {
    useEffect(() => {
        if (hidden) {
            handleChange('');
        }
    }, [handleChange, hidden]);
};
